import api from 'api';

export const loadApiIntegrationTable = api('POST /api/api-integrations/grid');
export const loadApiIntegrationDetails = api(
  'GET /api/api-integrations/:id/details'
);
export const loadApiIntegration = api('GET /api/api-integrations/:id');
export const createApiIntegration = api('POST /api/api-integrations');
export const updateApiIntegration = api('PUT /api/api-integrations/:id');

export const deleteApiIntegration = api(
  'POST /api/api-integrations/:id/delete'
);
